import { Button } from "@/components/Button";
import classNames from "classnames";

interface CreateAccountBannerProps {
  title: string;
  subtitle: string;
  buttonText: string;
  link?: string;
  hideOnMobile?: boolean;
  className?: string;
}

export const CreateAccountBanner = ({
  title,
  subtitle,
  buttonText,
  link = "/banner-bank",
  hideOnMobile = false,
  className,
}: CreateAccountBannerProps) => {
  return (
    <div
      id="bank-account"
      className={classNames("w-full", className, {
        "hidden lg:block": hideOnMobile,
      })}
    >
      <div className="flex flex-col items-center px-6 py-6">
        <h2 className="text-3xl md:text-4xl text-center font-semibold">
          {title}
        </h2>
        <h3 className="text-base md:text-lg lg:text-2xl text-center">
          {subtitle}
        </h3>
        <Button
          className="text-white !bg-primary-500 !font-light mt-6 !px-10 !py-3"
          link={link}
          text={buttonText}
        />
      </div>
    </div>
  );
};
